import React, { Component } from "react";
import ReactDOM from 'react-dom';
import "./ScoreCard.css";
import { Sidebar, Header } from "..";
//import PerformSampling from './PerformSampling';
import ScoreCardSearch from "./ScoreCardSearch";
import ViewScoreCardDetails from "./ViewScoreCardDetails";
import { Button, Row, Col, Modal } from "react-bootstrap";
import EndpointConstant from "./../../constants/EndpointConstant";
import utils from "./../../utils";
import Pagination from "../Pagination/Pagination";
import RoleConstant from "../../constants/RoleConstant";
import { v4 as uuidV4 } from "uuid";
import PopupModels from "../PopupModels/PopupModels";
import { ProgressBar } from "primereact/progressbar";
import MessageConstant from './../../constants/MessageConstant';
import { MemoryRouter } from "react-router-dom";
import html2canvas from "html2canvas";

class ScoreCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scorecardDetails: [],
      scoreCards: [],
      scoreCardsSort: [],
      sampleSize: 3,
      sampleName: "",
      sampledScorecards: [],
      viewDetails: false,
      showpagination: false,
      currentTodos: [],
      sId: "",
      downloadRequest: "Processing",
      showDataSync: false,
      extractValue: 0,
      extractSuccess: false,
      scorecardFilterData: {},
      selectedIds: new Set(),
      selectedScorecardsById: {},
      selectAll: false
    };
    // this.getScoreCardDetails=this.getScoreCardDetails.bind(this);
    this.onSortInteraction = this.onSortInteraction.bind(this);
    this.viewScoreCardDetails = this.viewScoreCardDetails.bind(this);
    this.hideViewDetails = this.hideViewDetails.bind(this);
    this.getScoreCardList = this.getScoreCardList.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.searchResults = this.searchResults.bind(this);
    this.setSampleName = this.setSampleName.bind(this);
    this.componentRef = React.createRef();
    this.handleOnClear = this.handleOnClear.bind(this);
    this.setScorecardList = this.setScorecardList.bind(this);
    this.downloadScorecard = this.downloadScorecard.bind(this);
    this.clearState = this.clearState.bind(this);
    this.getdownloadScorecardData = this.getdownloadScorecardData.bind(this);
    this.getdownloadScorecardDataFromDB =
      this.getdownloadScorecardDataFromDB.bind(this);
    this.hideDataSyncOnCancel = this.hideDataSyncOnCancel.bind(this);
    this.setFilterData = this.setFilterData.bind(this);
    // this.sleep = this.sleep.bind(this);
  }
  componentDidMount() {
    this.getScoreCardList();
    if (utils.getSessionItem("role") === RoleConstant.QualityMonitor) {
      this.getScoreCardList("stage1");
    }
  }
  clearState() {
    this.setState({
      scoreCards: [],
      scorecardFilterData: {},
      selectedIds: new Set(),
      selectedScorecardsById: {},
      selectAll: false,
    });
  }
  setFilterData(filterData) {
    this.setState({ scorecardFilterData: filterData });
  }
  getScoreCardList(stage) {
    // let data = {};
    let data = {
      datasetId: "All",
      stage: stage,
    };
    // let data={}
    let self = this;
    // utils.makeRequest(this, EndpointConstant.SCORECARD_LIST, data, function (result) {
    utils.makeRequest(
      this,
      EndpointConstant.SCORECARDS_LISTS_FROM_DATASET,
      data,
      async function (result) {
        if (!result.error) {
          utils.showLoader();
          await fetch(result.scorecards, {
            mode: "cors",
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
            method: "GET",
            body: null,
          })
            .then((response) => response.json())
            .then((s3ResponseJson) => {
              utils.hideLoader();
              const scorecards = s3ResponseJson;
              // let errors = [];
              self.loading = false;
              // let newscorecards=self.state.scoreCards.length>0?self.state.scoreCards.concat(scorecards):scorecards;
              // const end = Math.ceil((self.state.sampleSize/100)*scorecards.length);
              // const sampledScorecards = scorecards.slice(0, end);

              let datasetId = [];
              let options = [];
              let scorecardsShow = []
              if (utils.getSessionItem("role") == RoleConstant.Reviewer) {
                scorecards.forEach((item) => {
                  if ((item.assignedToId == utils.getSessionItem("userId")) || (item.assignedToAdmin == utils.getSessionItem("userId")) || (item.modifiedBy == utils.getSessionItem("userId"))) {
                    scorecardsShow.push(item)
                    if (!datasetId.includes(item.datasetId) && item.datasetName) {
                      datasetId.push(item.datasetId);
                      options.push({
                        id: item.datasetId,
                        datasetName: item.datasetName,
                        status: "Complete",
                      });
                    }
                  }
                });
              } else if (utils.getSessionItem("role") == RoleConstant.Admin) {
                let username = utils.getSessionItem("firstName") + ' ' + utils.getSessionItem("lastName")
                scorecards.forEach((item) => {
                  if (((item.assignedToId == utils.getSessionItem("userId")) && item.assignedToAdmin == "" && (item.amgenQCBy == username)) || ((item.assignedToId == utils.getSessionItem("userId")) && item.assignedToAdmin && item.status == "Completed" && (item.createdBy == utils.getSessionItem("userId"))) || (item.createdBy == utils.getSessionItem("userId")) || (item.assignedToAdmin == utils.getSessionItem("userId"))) {
                    scorecardsShow.push(item)
                    if (!datasetId.includes(item.datasetId) && item.datasetName) {
                      datasetId.push(item.datasetId);
                      options.push({
                        id: item.datasetId,
                        datasetName: item.datasetName,
                        status: "Complete",
                      });
                    }
                  }
                });
              } else {
                scorecards.forEach((item) => {
                  scorecardsShow.push(item)
                  if (!datasetId.includes(item.datasetId) && item.datasetName) {
                    datasetId.push(item.datasetId);
                    options.push({
                      id: item.datasetId,
                      datasetName: item.datasetName,
                      status: "Complete",
                    });
                  }
                })
              }
              self.setState(
                {
                  scoreCards: scorecardsShow,
                  scoreCardsSort: scorecards,
                  datasets: options,
                  selectedIds: new Set(),
                  selectedScorecardsById: {},
                  selectAll: false,
                },
                () => self.setState({ showpagination: true })
              );
            })
            .catch((error) => {
              let er;
              // console.error(error);
              // console.log("Testing 12345 Error");
            });
        } else {
          self.getScoreCardList("stage1");
        }
      }
    );
  }
  setScorecardList(scorecards) {
    let self = this;
    self.setState(
      {
        scoreCards: scorecards,
        sampledScorecards: scorecards,
        scoreCardsSort: scorecards,
        selectedIds: new Set(),
        selectedScorecardsById: {},
        selectAll: false,
      },
      () => self.setState({ showpagination: true })
    );
  }
  viewScoreCardDetails(id, datasetName) {
    //  debugger
    let self = this;
    let data = {
      id: id,
    };

    // this.setState({show:true})
    utils.makeRequest(
      this,
      EndpointConstant.SCORECARD_DETAILS,
      data,
      function (result) {
        const scorecardDetails = result.scorecardDetails;
        self.loading = false;
        scorecardDetails[0].datasetName = datasetName;
        self.setState({
          scorecardDetails: scorecardDetails,
          viewDetails: true,
        });
      }
    );
  }
  // componentDidMount(){
  //   this.getScoreCardDetails()
  // }
  // getScoreCardDetails(){
  //   this.setState({scorecardDetails:scorecardDetails,scoreCardsSort:scorecardDetails});
  // }
  // viewScoreCardDetails(id){
  // return(
  //   <Link to="ideas" params={{ testvalue: "hello" }}>Create Idea</Link>
  // )
  // this.setState({viewDetails:true})
  // }
  hideViewDetails() {
    this.setState({ viewDetails: false });
    this.getScoreCardList();
  }
  sortInteration(prop, sortId) {
    return (a, b) => {
      if (sortId.sortId === "sort") {
        return a[prop].toString().localeCompare(b[prop].toString());
      } else if (sortId.sortId === "sort-up") {
        return b[prop].toString().localeCompare(a[prop].toString());
      } else if (sortId.sortId === "sort-down") {
        return a;
      }
    };
  }
  onSortInteraction(data, e) {
    e.preventDefault();
    //console.log(e.target.className);
    let sortId = e.target.id;
    // let className = e.target.className;
    if (sortId === "sort") {
      e.target.id = "sort-up";
      e.target.className = "fas fa-sort-up";
    } else if (sortId === "sort-up") {
      e.target.id = "sort-down";
      e.target.className = "fas fa-sort-down";
    } else if (sortId === "sort-down") {
      e.target.id = "sort";
      e.target.className = "fas fa-sort";
    }
    const { scoreCardsSort } = this.state;
    switch (data) {
      case "caseno":
        // let interactionId = [...scoreCardsSort].sort(this.sortInteration('interactionId', { sortId: sortId }));
        this.setState({
          scorecards: [...scoreCardsSort].sort(
            this.sortInteration("interactionId", { sortId: sortId })
          ),
        });
        break;
      case "ifrtype":
        // let ifrtype = [...scoreCardsSort].sort(this.sortInteration('ifrtype', { sortId: sortId }));
        this.setState({
          scorecards: [...scoreCardsSort].sort(
            this.sortInteration("ifrtype", { sortId: sortId })
          ),
        });
        break;
      case "channel":
        // let channel = [...scoreCardsSort].sort(this.sortInteration('channel', { sortId: sortId }));
        this.setState({
          scorecards: [...scoreCardsSort].sort(
            this.sortInteration("channel", { sortId: sortId })
          ),
        });
        break;
      case "attachemnt":
        // let attachemnt = [...scoreCardsSort].sort(this.sortInteration('attachemnt', { sortId: sortId }));
        this.setState({
          scorecards: [...scoreCardsSort].sort(
            this.sortInteration("attachemnt", { sortId: sortId })
          ),
        });
        break;
      case "qmassociate":
        // let qmassociate = [...scoreCardsSort].sort(this.sortInteration('qmassociate', { sortId: sortId }));
        this.setState({
          scorecards: [...scoreCardsSort].sort(
            this.sortInteration("qmassociate", { sortId: sortId })
          ),
        });
        break;
      case "tcsqc":
        // let tcsqc = [...scoreCardsSort].sort(this.sortInteration('tcsqc', { sortId: sortId }));
        this.setState({
          scorecards: [...scoreCardsSort].sort(
            this.sortInteration("tcsqc", { sortId: sortId })
          ),
        });
        break;
      case "amgenqc":
        // let amgenqc = [...scoreCardsSort].sort(this.sortInteration('amgenqc', { sortId: sortId }));
        this.setState({
          scorecards: [...scoreCardsSort].sort(
            this.sortInteration("amgenqc", { sortId: sortId })
          ),
        });
        break;
      default:
        break;
    }
  }
  onChangePage(currentTodos) {
    this.setState({ currentTodos: currentTodos }, () => {
      const selectAll =
        currentTodos.length > 0 &&
        currentTodos.every((row) => this.isSelected(row.id));
      this.setState({ showpagination: true, selectAll });
    });
  }
  searchResults(searchData) {
    // debugger
    this.setState({
      scoreCards: searchData,
      selectedIds: new Set(),
      selectedScorecardsById: {},
      selectAll: false,
    }, () => {
      this.setState({ showpagination: true });
    });
  }
  setSampleName(sampleName) {
    this.setState({ sampleName: sampleName });
  }
  handleOnClear(flag) {
    if (
      utils.getSessionItem("role") === RoleConstant.Admin ||
      utils.getSessionItem("role") === RoleConstant.QualityMonitor
    ) {
      this.componentRef.current.handleOnClear(flag);
    }
  }

  // getdownloadScorecardData() {
  //   let { scoreCards } = this.state;
  //   let data = {};
  //   data.scorecardIds = scoreCards.map(ssc => ssc.id);
  //   utils.makeRequest(this, EndpointConstant.DOWNLOAD_SCORECARD, data, function (result) {
  //     // console.log(JSON.stringify(result));
  //     window.open(result.downloadUrl, 'Download');
  //   })
  // }

  // Normalize from prevState ONLY (not this.state)
getSelectedIdsSet = (prevState) => {
  const s = prevState?.selectedIds ?? this.state.selectedIds;
  if (s instanceof Set) return s;
  if (Array.isArray(s)) return new Set(s);
  if (typeof s === 'string' && s) return new Set([s]); // just in case legacy
  return new Set();
};

getSelectedIdsArray = () => Array.from(this.getSelectedIdsSet(this.state));

getSelectedScorecardMeta = (id) => {
  const key = String(id);
  return this.state.selectedScorecardsById[key] || null;
};

getScoreCardMeta = (id) => {
  const key = String(id);
  return (this.state.scoreCards || []).find((item) => String(item.id) === key) || null;
};

// Read
isSelected = (id) => {
  const key = String(id);
  return this.state.selectedIds instanceof Set && this.state.selectedIds.has(key);
};

// Write (always create a NEW Set from prev)
toggleSelection = (scorecard) => {
  this.setState(prev => {
    const key = String(scorecard.id);
    const base = prev.selectedIds instanceof Set
      ? new Set(prev.selectedIds)
      : this.getSelectedIdsSet(prev);
    const metadata = { ...(prev.selectedScorecardsById || {}) };

    if (base.has(key)) {
      base.delete(key);
      delete metadata[key];
    } else {
      base.add(key);
      metadata[key] = {
        id: scorecard.id,
        datasetName: scorecard.datasetName || "",
      };
    }

    const currentRows = prev.currentTodos || [];
    const isAllSelected =
      currentRows.length > 0 &&
      currentRows.every((row) => base.has(String(row.id)));

    return {
      selectedIds: base,
      selectedScorecardsById: metadata,
      selectAll: isAllSelected,
    };
  });
};

clearSelections = () => {
  this.setState({
    selectedIds: new Set(),
    selectedScorecardsById: {},
    selectAll: false
  });
};



generateHtml2Canvas = async (element, pdf) => {
  const blockRects = [];
  const lineRects = [];
  const headingRects = [];
  let captureBounds;
  const canvas = await html2canvas(element, {
    backgroundColor: "#ffffff",
    scale: window.devicePixelRatio || 2,
    useCORS: true,
    scrollX: 0,
    scrollY: 0,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
    onclone: (doc, clonedElement) => {
      const exportRoot = doc.getElementById('export-root');
      if (exportRoot) {
        exportRoot.style.opacity = '1';
        exportRoot.style.left = '0';
        exportRoot.style.overflow = 'visible';
      }
      doc.querySelectorAll("textarea").forEach((textarea) => {
        if (!textarea.value || textarea.value.trim() === "") {
          textarea.value = " ";
        }
      });
      const captureElement = clonedElement || doc.getElementById(element.id);
      
      captureElement.querySelectorAll('.agent-notes, .agent-notes .scroll').forEach((notes) => {
        Object.assign(notes.style, {
          height: 'auto',
          maxHeight: 'none',
          overflow: 'visible',
          display: 'block',
        });
      });
      captureBounds = captureElement.getBoundingClientRect();
      captureElement.querySelectorAll(
        '.lable-width, table tr, .score-card-total-1 > .row, .layout-2 > .row:first-child, .layout-2 .card'
      ).forEach((block) => {
        blockRects.push(block.getBoundingClientRect());
      });
      captureElement.querySelectorAll('input, select, textarea, .multi-select .dropdown-heading').forEach((control) => {
        lineRects.push(control.getBoundingClientRect());
      });
      const keepHeadingWithContent = (heading, content) => {
        if (!content) return;
        const walker = doc.createTreeWalker(content, NodeFilter.SHOW_TEXT);
        const range = doc.createRange();
        let node = walker.nextNode();
        while (node) {
          if (node.textContent.trim()) {
            range.selectNodeContents(node);
            const firstLine = Array.from(range.getClientRects()).find((rect) => rect.height > 0);
            if (firstLine) {
              headingRects.push({
                top: heading.getBoundingClientRect().top,
                bottom: firstLine.bottom,
              });
              return;
            }
          }
          node = walker.nextNode();
        }
      };
      captureElement.querySelectorAll('table thead').forEach((heading) => {
        const firstRow = heading.parentElement.querySelector('tbody tr');
        const firstQuestion = firstRow && firstRow.classList.contains('section-header-row')
          ? firstRow.nextElementSibling
          : firstRow;
        keepHeadingWithContent(heading, firstQuestion || firstRow);
      });
      captureElement.querySelectorAll('.section-header-row').forEach((heading) => {
        keepHeadingWithContent(heading, heading.nextElementSibling);
      });
      captureElement.querySelectorAll('.commentHistory .cmt').forEach((heading) => {
        keepHeadingWithContent(heading, heading.parentElement.querySelector('.card-body'));
      });
      captureElement.querySelectorAll('.layout-2 label').forEach((heading) => {
        const row = heading.closest('.row');
        const notes = row && row.querySelector('.agent-notes');
        const content = notes && notes.textContent.trim() ? notes : row && row.nextElementSibling;
        keepHeadingWithContent(heading, content);
      });
      const title = captureElement.querySelector('.heading-interaction');
      if (title) {
        keepHeadingWithContent(title, captureElement.querySelector('.lable-width'));
      }
      const textWalker = doc.createTreeWalker(captureElement, NodeFilter.SHOW_TEXT);
      const textRange = doc.createRange();
      let textNode = textWalker.nextNode();
      while (textNode) {
        if (textNode.textContent.trim()) {
          textRange.selectNodeContents(textNode);
          lineRects.push(...Array.from(textRange.getClientRects()));
        }
        textNode = textWalker.nextNode();
      }
    }
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const horizontalMargin = 24;
  const verticalMargin = 30;
  const contentWidth = pageWidth - (horizontalMargin * 2);
  const contentHeight = pageHeight - (verticalMargin * 2);
  const pixelsPerPoint = canvas.width / contentWidth;
  const maxPagePixels = Math.max(1, Math.floor(contentHeight * pixelsPerPoint));
  const canvasScale = canvas.width / captureBounds.width;
  const toPixelRange = (rect) => {
    const top = Math.max(0, Math.floor((rect.top - captureBounds.top) * canvasScale));
    const bottom = Math.min(canvas.height, Math.ceil((rect.bottom - captureBounds.top) * canvasScale));
    return { top, bottom };
  };
  const blockRanges = blockRects.map(toPixelRange).filter(({ top, bottom }) =>
    bottom > top && bottom - top <= maxPagePixels * 0.25
  );
  const lineRanges = lineRects.concat(headingRects).map(toPixelRange).filter(({ top, bottom }) =>
    bottom > top && bottom - top < maxPagePixels
  );
  const findBoundary = (limit, start, ranges) => {
    let boundary = limit;
    let previousBoundary;
    do {
      previousBoundary = boundary;
      ranges.forEach(({ top, bottom }) => {
        if (top > start && top < boundary && bottom > boundary) {
          boundary = top;
        }
      });
    } while (boundary < previousBoundary);
    return boundary;
  };

  let sourceTop = 0;
  while (sourceTop < canvas.height) {
    let sourceBottom = Math.min(sourceTop + maxPagePixels, canvas.height);
    if (sourceBottom < canvas.height) {
      const minimumBottom = sourceTop + Math.floor(maxPagePixels * 0.85);
      const preferredBottom = findBoundary(sourceBottom, sourceTop, blockRanges);
      if (preferredBottom >= minimumBottom) {
        sourceBottom = preferredBottom;
      }
      sourceBottom = findBoundary(sourceBottom, sourceTop, lineRanges);
    }

    const pageCanvas = document.createElement('canvas');
    pageCanvas.width = canvas.width;
    pageCanvas.height = sourceBottom - sourceTop;
    const context = pageCanvas.getContext('2d');
    context.drawImage(
      canvas,
      0, sourceTop, canvas.width, pageCanvas.height,
      0, 0, canvas.width, pageCanvas.height
    );

    if (sourceTop > 0) {
      pdf.addPage();
    }

    pdf.addImage(
      pageCanvas.toDataURL("image/jpeg", 1.0),
      "JPEG",
      horizontalMargin,
      verticalMargin,
      contentWidth,
      pageCanvas.height / pixelsPerPoint
    );

    sourceTop = sourceBottom;
  }
};

waitForExportContent = async (element) => {
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }

  const images = Array.from(element.querySelectorAll("img"));
  await Promise.all(images.map((image) => {
    if (image.complete) return Promise.resolve();
    return new Promise((resolve) => {
      image.addEventListener("load", resolve, { once: true });
      image.addEventListener("error", resolve, { once: true });
    });
  }));

  await new Promise((resolve) => requestAnimationFrame(() => {
    requestAnimationFrame(resolve);
  }));
};

downloadSelectedScorecardsMerged = async () => {
  const jsPDFLib = window.jsPDF;
  if (!jsPDFLib) {
    alert('html2canvas / jsPDF not available.');
    return;
  }

  const ids = this.getSelectedIdsArray();
  if (!ids.length) {
    alert('Please select at least one scorecard.');
    return;
  }

  const container = document.createElement('div');
  container.id = 'export-root';
  container.className = 'scorecard-export-root';
  container.setAttribute('aria-hidden', 'true');
  Object.assign(container.style, {
    position: 'fixed',
    left: '-100000px',
    top: '0',
    width: '1200px',
    height: 'auto',
    background: '#fff',
    opacity: '0',
    pointerEvents: 'none',
    overflow: 'hidden',
    zIndex: '-1'
  });
  document.body.appendChild(container);

  const pdf = new jsPDFLib("landscape", "pt", "a4");
  let isFirstScorecard = true;

  try {
    utils?.showLoader?.();

    for (const id of ids) {
      const { scorecardDetails } = await new Promise((resolve) => {
        utils.makeRequestInBackground(this, EndpointConstant.SCORECARD_DETAILS, { id }, resolve);
      });

      const detailsArrayRaw = Array.isArray(scorecardDetails)
        ? scorecardDetails
        : (scorecardDetails ? [scorecardDetails] : []);

      const selectedMeta = this.getSelectedScorecardMeta(id);
      const rowMeta = this.getScoreCardMeta(id);
      const datasetName =
        selectedMeta?.datasetName ||
        rowMeta?.datasetName ||
        '';

      const detailsArray = detailsArrayRaw.map((obj, idx) => {
        if (idx !== 0 || !obj || typeof obj !== 'object') return obj;
        if (obj.scoreDetails && typeof obj.scoreDetails === 'object') {
          return {
            ...obj,
            scoreDetails: { ...obj.scoreDetails, datasetName },
          };
        }
        return { ...obj, datasetName };
      });

      const jsx = (
        <MemoryRouter>
          <div style={{ width: '100%', background: '#fff', color: '#000' }}>
            <ViewScoreCardDetails
              scorecard="old"
              details={detailsArray}
            />
          </div>
        </MemoryRouter>
      );
      ReactDOM.render(jsx, container);

      const pageEl = container.querySelector('#page');
      await this.waitForExportContent(pageEl);

      if (!isFirstScorecard) {
        pdf.addPage();
      }
      await this.generateHtml2Canvas(pageEl, pdf);
      isFirstScorecard = false;

      ReactDOM.unmountComponentAtNode(container);
      container.innerHTML = '';
    }

    pdf.save(`Scorecards_${new Date().toISOString().slice(0, 10)}.pdf`);
    this.clearSelections();
  } catch (e) {
    console.error('Merged export failed:', e);
    alert('Failed to generate PDF. Check console for details.');
  } finally {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
    utils?.hideLoader?.();
  }
};

  getdownloadScorecardData() {
    let { scoreCards } = this.state;
    let self = this;
    let payload = {
      // scorecardIds: scoreCards.map((ssc) => ssc.id),
      ...this.state.scorecardFilterData
    };
    payload.sId = uuidV4();
    this.setState({
      sId: payload.sId,
      // scorecardIds: scoreCards.map((ssc) => ssc.id),
      downloadRequest: "Processing",
    });

    // console.log("in 257:"+JSON.stringify(payload));
    //console.log("in 258:"+this.state.sId);
    utils.makeRequestInBackground(
      this,
      EndpointConstant.DOWNLOAD_SCORECARD,
      payload,
      function (result) {
        //console.log("in 247:"+JSON.stringify(result));
        //   self.setState({
        //     downloadRequest: "Processing"
        //  });
      }
    );
  }


pollingInFlight = false;

getdownloadScorecardDataFromDB() {
  if (this.pollingInFlight) return;               
  this.pollingInFlight = true;

  const data = {
    sId: this.state.sId,
    downloadRequest: this.state.downloadRequest,
  };

  const self = this;
  utils.makeRequestInBackground(
    this,
    EndpointConstant.DOWNLOAD_SCORECARD,
    data,
    (result) => {                                
      self.pollingInFlight = false;

      if (result.downloadRequest === "Completed") {
        self.setState({ downloadRequest: result.downloadRequest });
        
        const url = result.downloadUrl || result.url;
        if (url) {        
          window.location.assign(url);
        }

        self.hideDataSyncOnCancel();
        self.setState({
          extractSuccess: true,
          extractValue: 0,
          extractResponseMsg: MessageConstant.DOWNLOADED_SCORECARD,
          extractResponseFlagIcon: "success",
        });

        if (self.interval) {
          clearInterval(self.interval);
          self.interval = null;
        }
      } else {
        self.setState({ downloadRequest: result.downloadRequest });
      }
    }
  );
}

  // getdownloadScorecardDataFromDB() {
  //   let data = {
  //     sId: this.state.sId,
  //     //scorecardIds: scoreCards.map(ssc => ssc.id),
  //     downloadRequest: this.state.downloadRequest,
  //   };
  //   // console.log("in 244 data:"+JSON.stringify(data));

  //   let self = this;
  //   utils.makeRequestInBackground(
  //     this,
  //     EndpointConstant.DOWNLOAD_SCORECARD,
  //     data,
  //     function (result) {
  //       //console.log("in 247:"+JSON.stringify(result));
  //       if (result.downloadRequest == "Completed") {
  //         self.setState({ downloadRequest: result.downloadRequest });
  //         window.open(result.url, "Download");
  //         this.hideDataSyncOnCancel();
  //         this.setState({
  //           extractSuccess: true,
  //           extractValue: 0,
  //           extractResponseMsg: MessageConstant.DOWNLOADED_SCORECARD,
  //           extractResponseFlagIcon: "success",
  //         });
  //       } else {
  //         self.setState({ downloadRequest: result.downloadRequest });
  //       }
  //     }
  //   );
  // }

  downloadScorecard(event) {
    event.preventDefault();
    // console.log("extract Data from bio connect");
    //  clearInterval(this.interval);
    // console.log("this state",this.state);
    this.setState({
      showDataSync: true,
    });
    this.getdownloadScorecardData();
    this.interval = setInterval(() => {
      let val = this.state.extractValue;
      val += Math.floor(Math.random() * 5) + 1;
      if (val >= 99) {
        val = 99;
      }

      this.setState({
        extractValue: val,
      });
      //   console.log("downloadss",this.state.downloadRequest1, this.state.downloadRequest1 === "Processing")
      this.state.downloadRequest == "Processing"
        ? this.getdownloadScorecardDataFromDB()
        : "";
      // console.log("download Request 290:"+this.state.downloadRequest);
      if (this.state.downloadRequest == "Completed") {
        this.hideDataSyncOnCancel();
        this.setState({
          extractSuccess: true,
          extractValue: 0,
          extractResponseMsg: MessageConstant.DOWNLOADED_SCORECARD,
          extractResponseFlagIcon: "success",
        });
        clearInterval(this.interval);
        this.interval = null;
      }
    }, 10000);
  }

  handleExtractSuccessClose() {
    this.setState({
      extractSuccess: false,
    });
  }

  hideDataSyncOnCancel() {
    //event.preventDefault();
    this.setState({
      showDataSync: false,
      extractValue: 0,
      // downloadRequest: 'Processing',
      downloadUrl: "",
      sId: "",
      // extractSuccess: true,
      // extractResponseMsg: MessageConstant.DOWNLOADED_SCORECARD,
      // extractResponseFlagIcon: 'success'
    });
    clearInterval(this.interval);
    this.interval = null;
  }

  add3Dots(string, limit) {
    var dots = "...";
    if (string && string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }
  render() {
    const { viewDetails, scorecardDetails, datasets } = this.state;
    // const siteinfo = JSON.parse(utils.getSessionItem("SiteInfo"));
    //const role = utils.getSessionItem("role")
    //// console.log(siteinfo.ScorecardLabels)
    // console.log(datasets,datasets)
    const scorecardList = this.state.currentTodos.map((data, index) => {
      return (
        <tr key={index}>
          <td>
            <label className="row-select">
             <input
              type="checkbox"
              checked={this.isSelected(data.id)}
              onChange={() => this.toggleSelection(data)}
              />
            </label>
          </td>
          <td>{data.subcaseNumber && data.subcaseNumber.toUpperCase()}</td>
          {/* <td>{data.IFRType}</td> */}
          <td title={data.datasetName}>
            {this.add3Dots(data.datasetName, 18)}
          </td>
          <td>{data.ScorecardName}</td>
          <td>{data.channel}</td>
          <td>{data.finalScore}</td>
          {/* for camel case letter */}
          <td>
            {data.questionStatus.charAt(0).toUpperCase() +
              data.questionStatus.slice(1)}
          </td>
          {/* <td>{data.attachmentIncluded}</td> */}
          <td>{data.QMAssociate}</td>
          {/* <td>{data.qualityMonitorQCBy}</td> */}
          {/* <td>{data.selectedForQCBy}</td> */}
          <td>{data.amgenQCBy ? data.amgenQCBy : "-"}</td>
          <td>
            {" "}
            <a
              className="view-details"
              onClick={() =>
                this.viewScoreCardDetails(data.id, data.datasetName)
              }
            >
              <i className="fa fa-eye"></i>&nbsp;View Details
            </a>
          </td>
        </tr>
      );
    });
    return (
      <div>
        <Header />
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="menu-content">
          {/* {viewDetails ? '' : (role === RoleConstant.Admin || role === RoleConstant.SuperAdmin) && <PerformSampling ref={this.componentRef} getSampleName={this.setSampleName} getScorecardList={this.setScorecardList} getSearchResult={this.searchResults} clearState={this.clearState}/>} */}
          {viewDetails ? (
            ""
          ) : (
            <ScoreCardSearch
              sampleName={this.state.sampleName}
              datasets={this.state.datasets}
              getScoreCardList={this.getScoreCardList}
              getSearchResult={this.searchResults}
              clearState={this.clearState}
              setFilterData={this.setFilterData}
            />
          )}
          {viewDetails ? (
            <ViewScoreCardDetails
              scorecard="old"
              details={scorecardDetails}
              hideDetails={this.hideViewDetails}
            />
          ) : (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Download PDF</th>
                    <th>Sub-Case Number</th>
                    {/* <th'ifrtype', e)}>IFR Type</th> */}
                    <th>Dataset</th>
                    <th>Scorecard Name</th>
                    <th>Intake Channel Type</th>
                    <th>Scorecard Final Score</th>
                    <th>Question Status</th>
                    {/* <th>Attachment</th> */}
                    <th>QM Associate</th>
                    {/* <th>Quality Monitor QC By</th> */}
                    {/* <th'amgenqc', e)}>Selected for QC By</th> */}
                    <th>Amgen QC By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{scorecardList}</tbody>
              </table>
              <Row className="padding-top">
                <Col>
                  {this.state.showpagination ? (
                    <Pagination
                      data={this.state.scoreCards}
                      onChangePage={this.onChangePage}
                    />
                  ) : (
                    ""
                  )}
                </Col>
                <Col className="right-align">
                  <Button
                    className="button-color download-font-size"
                    onClick={this.downloadScorecard}
                  >
                    Download Score Card
                  </Button>
                  <Button
                    className="button-color download-font-size report"
                    onClick={this.downloadSelectedScorecardsMerged}
                  >
                    Download Selected Report
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </div>
        <Modal
          show={this.state.showDataSync}
          onHide={this.hideDataSyncOnCancel}
          className="dataset-extract-dialog"
        >
          <Modal.Header closeButton>
            <Modal.Title>DOWNLOAD SCORE CARD</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ProgressBar
              style={{
                height: "10px",
                borderRadius: "5px",
                border: "1px solid #0063C3",
                background: "#F2F2F2",
              }}
              showValue={false}
              value={this.state.extractValue}
            />
            <p className="progressMsg">Downloading is in progress...</p>
            <p className="progressMsg">{this.state.extractValue}% completed</p>
          </Modal.Body>
          <Modal.Footer className="confirm-popup-header">
            <Button
              variant="primary"
              className="clear "
              onClick={this.hideDataSyncOnCancel}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <PopupModels
          showPopup={this.state.extractSuccess}
          iconFlag={this.state.extractResponseFlagIcon}
          message={this.state.extractResponseMsg}
          handleClosePopup={this.handleExtractSuccessClose.bind(this)}
        />
      </div>
    );
  }
}

export default ScoreCard;